import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from "../../assets/Images/logo.png";
import { Link } from "react-router-dom";


const Header = () => {

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [servicesData, setServicesData] = useState([]); // ✅ NEW

  const closeMenu = () => {
    setMenuOpen(false);
    setServicesOpen(false);
  };

  useEffect(() => {
    fetch(`${BASE_URL}Services/home`)
      .then((res) => res.json())
      .then((data) => setServicesData(data.data || []))
      .catch((err) => console.log(err));
  }, []);

  const createSlug = (title) =>
    title?.toLowerCase().replace(/\s+/g, "-");

  return (
    <header className="main-header">

      <div className="container header-flex">

        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>

        <nav className={`navbar ${menuOpen ? "open" : ""}`}>

          <ul className="nav-menu">

            <li>
              <Link to="/" className="nav-link" onClick={closeMenu}>
                Home
              </Link>
            </li>

            <li>
              <Link to="/about" className="nav-link" onClick={closeMenu}>
                About Us
              </Link>
            </li>

            <li className={`dropdown ${servicesOpen ? "open" : ""}`}>

              <div className="services-link">

                <Link
                  to="/services"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  Services
                </Link>

                <span
                  className="dropdown-arrow"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setServicesOpen(!servicesOpen);
                  }}
                >
                  ▾
                </span>

              </div>

              <ul className="dropdown-menu">

                {servicesData.map((item, i) => (
                  <li key={i}>
                    <Link
                      to={`/service-details/${createSlug(item.title)}`} 
                      onClick={closeMenu}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}

              </ul>

            </li>

            <li>
              <Link to="/iso" className="nav-link" onClick={closeMenu}>
                 ISO Standards
              </Link>
            </li>

            <li>
              <Link to="/blog" className="nav-link" onClick={closeMenu}>
                 Blog
              </Link>
            </li>

            <li>
              <Link to="/careers" className="nav-link" onClick={closeMenu}>
                Careers
              </Link>
            </li>

          </ul>

          <Link to="/ContactUs" className="btn-contact" onClick={closeMenu}>
            Contact Us
          </Link>

        </nav>

        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>

    </header>
  );
};

export default Header;